import menuKobeMinatomachi from "../../../assets/menu-kobe-minatomachi.jpg";
import menuHamburg from "../../../assets/menu-hamburg.jpg";
import menuKakuni from "../../../assets/menu-kakuni.jpg";
import menuMixgrill from "../../../assets/menu-mixgrill.jpg";
import menuSteak from "../../../assets/menu-steak.jpg";
import menuBokkake from "../../../assets/menu-bokkake.jpg";
import { findCurryByNo, PRICE_RANGE, RICE_SIZE, HALF_PRICE_PROMO } from "../../../data/menuData";

const menu = [
  {
    curryNo: 1,
    name: "神戸ミナトマチ\nカレー",
    badge: "人気No.1",
    badgeColor: "bg-primary-600",
    desc: "じっくり煮込んだ牛肉の旨みとスパイスの香りが決め手の、当店看板の一皿。",
    image: menuKobeMinatomachi,
  },
  {
    curryNo: 10,
    name: "名物ハンバーグ\nカレー",
    badge: "",
    badgeColor: "",
    desc: "ジューシーなハンバーグをまるごとのせた、食べ応え満点の一皿。",
    image: menuHamburg,
  },
  {
    curryNo: 12,
    name: "とろとろ角煮\nカレー",
    badge: "",
    badgeColor: "",
    desc: "とろけるほど柔らかく煮込んだ角煮がカレーに溶け合う、至福の味わい。",
    image: menuKakuni,
  },
  {
    curryNo: 14,
    name: "ミックスグリル\nカレー",
    badge: "背徳の…！",
    badgeColor: "bg-primary-600",
    desc: "お肉をたっぷり味わえる、欲張りな盛り合わせの一皿。",
    image: menuMixgrill,
  },
  {
    curryNo: 15,
    name: "神戸ミナトマチ\nステーキカレー",
    badge: "ごちそう豪快！",
    badgeColor: "bg-primary-600",
    desc: "豪快なステーキをまるごとのせた、ごちそう感あふれる一皿。",
    image: menuSteak,
  },
  {
    curryNo: 7,
    name: "神戸名物\nぼっかけカレー",
    badge: "神戸名物",
    badgeColor: "bg-accent-500 text-secondary-900",
    desc: "とろけるまで煮込んだ牛すじがたっぷり。神戸長田生まれのソウルフード「ぼっかけ」を一皿に。",
    image: menuBokkake,
  },
];

export default function Menu() {
  return (
    <section
      id="menu"
      className="relative py-20 md:py-24 bg-secondary-900 text-background-50"
    >
      {/* rope top */}
      <div className="rope-border absolute top-0 left-0 right-0 opacity-90" />

      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-3 mb-3">
            <span className="h-px w-8 bg-accent-400" />
            <span className="font-label tracking-widest text-accent-300 text-sm">
              MENU
            </span>
            <span className="h-px w-8 bg-accent-400" />
          </div>
          <h2 className="font-heading font-black text-3xl md:text-4xl">
            おすすめ<span className="text-accent-400">メニュー</span>
          </h2>
          <p className="mt-3 text-sm md:text-base text-accent-200 font-bold">
            カレー 税込{PRICE_RANGE.curryMin.toLocaleString()}円〜{PRICE_RANGE.curryMax.toLocaleString()}円／
            トッピング 税込{PRICE_RANGE.toppingMin}円〜{PRICE_RANGE.toppingMax}円
          </p>
        </div>

        {HALF_PRICE_PROMO.active && (() => {
          const promoCurry = findCurryByNo(HALF_PRICE_PROMO.targetCurryNo);
          return (
            <div className="mb-10 bg-primary-600 border-2 border-accent-400 rounded-2xl px-5 py-5 md:px-8 md:py-6 flex flex-col md:flex-row items-center gap-4 md:gap-6 text-center md:text-left">
              <div className="shrink-0 bg-accent-500 text-secondary-900 font-heading font-black text-sm md:text-base px-4 py-2 rounded-full whitespace-nowrap">
                {HALF_PRICE_PROMO.title}
              </div>
              <div className="flex-1">
                <p className="font-heading font-black text-base md:text-xl text-background-50 leading-snug">
                  {promoCurry?.name.replace("\n", "")} レギュラーサイズが半額！
                </p>
                <p className="text-xs md:text-sm text-background-100 mt-1">
                  {HALF_PRICE_PROMO.condition}／{HALF_PRICE_PROMO.period}
                </p>
              </div>
              <div className="shrink-0 flex items-baseline gap-2">
                <span className="text-background-200 text-sm md:text-base line-through">
                  税込{HALF_PRICE_PROMO.regularTax.toLocaleString()}円
                </span>
                <span className="font-heading font-black text-accent-300 text-2xl md:text-4xl">
                  税込{HALF_PRICE_PROMO.promoTax.toLocaleString()}円
                </span>
              </div>
            </div>
          );
        })()}

        <div
          data-product-shop
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5"
        >
          {menu.map((m) => {
            const curry = findCurryByNo(m.curryNo);
            const isHalfPrice = HALF_PRICE_PROMO.active && m.curryNo === HALF_PRICE_PROMO.targetCurryNo;
            return (
              <div
                key={m.name}
                className={`bg-background-50 rounded-xl overflow-hidden border-2 hover:-translate-y-1 transition-transform relative flex flex-col ${
                  isHalfPrice ? "border-accent-500" : "border-background-50"
                }`}
              >
                {m.badge && (
                  <div
                    className={`absolute top-3 left-3 z-10 ${m.badgeColor} text-background-50 dark:text-foreground-950 text-[10px] md:text-xs font-heading font-black px-2 py-1 rounded-full whitespace-nowrap`}
                  >
                    {m.badge}
                  </div>
                )}
                {isHalfPrice && (
                  <div className="absolute top-3 right-3 z-10 bg-accent-500 text-secondary-900 text-[10px] md:text-xs font-heading font-black px-2 py-1 rounded-full whitespace-nowrap rotate-[6deg] shadow">
                    半額！
                  </div>
                )}
                <div className="aspect-square bg-background-100 overflow-hidden">
                  <img
                    src={m.image}
                    alt={m.name.replace("\n", "")}
                    width={400}
                    height={400}
                    loading="lazy"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-3 md:p-4 text-foreground-950 flex flex-col flex-1">
                  <h3 className="font-heading font-black text-sm md:text-base mb-1 leading-tight">
                    {m.name.split("\n").map((line, i) => (
                      <span key={i} className="block">
                        {line}
                      </span>
                    ))}
                  </h3>
                  <p className="text-[11px] md:text-xs text-foreground-700 leading-relaxed line-clamp-3 mb-2">
                    {m.desc}
                  </p>
                  {curry && (
                    <div className="mt-auto pt-2 border-t border-background-200">
                      {isHalfPrice ? (
                        <div className="flex items-baseline gap-1.5 flex-wrap">
                          <span className="text-foreground-500 text-xs line-through">
                            税込{HALF_PRICE_PROMO.regularTax.toLocaleString()}円
                          </span>
                          <span className="font-heading font-black text-primary-700 text-sm md:text-base leading-none">
                            税込{HALF_PRICE_PROMO.promoTax.toLocaleString()}円〜
                          </span>
                        </div>
                      ) : (
                        <p className="font-heading font-black text-primary-700 text-sm md:text-base leading-none">
                          税込{curry.sizes.R.tax.toLocaleString()}円〜
                        </p>
                      )}
                      <p className="text-[10px] text-foreground-500 mt-1">
                        {isHalfPrice ? HALF_PRICE_PROMO.condition : "S/R/Lサイズあり"}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>

        <p className="text-center text-xs text-background-200 mt-6">
          ※価格はすべて税込表示です。ライス量はS{RICE_SIZE.S}／R{RICE_SIZE.R}／L{RICE_SIZE.L}。
          メニュー内容・価格は変更になる場合がございます。
        </p>

        <div className="mt-8 text-center">
          <a
            href="#store"
            className="inline-flex items-center gap-2 h-11 min-h-[44px] px-6 rounded-full bg-accent-500 hover:bg-accent-600 text-secondary-900 font-heading font-bold whitespace-nowrap cursor-pointer transition"
          >
            全メニュー・店舗情報を見る
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>

      <div className="rope-border absolute bottom-0 left-0 right-0 opacity-90" />
    </section>
  );
}
